import React, { useEffect } from "react";

export default function PotentialProfitTotals({
  incomes,
  potentialIncomes,
  expenses,
  potentialExpenses,
  potentialProfit,
  setPotentialProfit,
}) {
  useEffect(() => {
    setPotentialProfit({
      month1:
        Number(incomes.month1) +
        Number(potentialIncomes.month1) -
        (Number(expenses.month1) + Number(potentialExpenses.month1)),
      month2:
        Number(incomes.month2) +
        Number(potentialIncomes.month2) -
        (Number(expenses.month2) + Number(potentialExpenses.month2)),
      month3:
        Number(incomes.month3) +
        Number(potentialIncomes.month3) -
        (Number(expenses.month3) + Number(potentialExpenses.month3)),
      month4:
        Number(incomes.month4) +
        Number(potentialIncomes.month4) -
        (Number(expenses.month4) + Number(potentialExpenses.month4)),
      month5:
        Number(incomes.month5) +
        Number(potentialIncomes.month5) -
        (Number(expenses.month5) + Number(potentialExpenses.month5)),
      month6:
        Number(incomes.month6) +
        Number(potentialIncomes.month6) -
        (Number(expenses.month6) + Number(potentialExpenses.month6)),
      month7:
        Number(incomes.month7) +
        Number(potentialIncomes.month7) -
        (Number(expenses.month7) + Number(potentialExpenses.month7)),
      month8:
        Number(incomes.month8) +
        Number(potentialIncomes.month8) -
        (Number(expenses.month8) + Number(potentialExpenses.month8)),

      month9:
        Number(incomes.month9) +
        Number(potentialIncomes.month9) -
        (Number(expenses.month9) + Number(potentialExpenses.month9)),
      month10:
        Number(incomes.month10) +
        Number(potentialIncomes.month10) -
        (Number(expenses.month10) + Number(potentialExpenses.month10)),
      month11:
        Number(incomes.month11) +
        Number(potentialIncomes.month11) -
        (Number(expenses.month11) + Number(potentialExpenses.month11)),
      month12:
        Number(incomes.month12) +
        Number(potentialIncomes.month12) -
        (Number(expenses.month12) + Number(potentialExpenses.month12)),
    });
  }, [incomes, potentialIncomes, expenses, potentialExpenses]);

  return (
    <tr>
      <td className="alignLeft hideBorders">Potential Profit</td>
      <td className="hideBorders">{potentialProfit.month1}</td>
      <td className="hideBorders">{potentialProfit.month2}</td>
      <td className="hideBorders">{potentialProfit.month3}</td>
      <td className="hideBorders">{potentialProfit.month4}</td>
      <td className="hideBorders">{potentialProfit.month5}</td>
      <td className="hideBorders">{potentialProfit.month6}</td>
      <td className="hideBorders">{potentialProfit.month7}</td>
      <td className="hideBorders">{potentialProfit.month8}</td>
      <td className="hideBorders">{potentialProfit.month9}</td>
      <td className="hideBorders">{potentialProfit.month10}</td>
      <td className="hideBorders">{potentialProfit.month11}</td>
      <td className="hideBorders">{potentialProfit.month12}</td>
    </tr>
  );
}
